import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { resolveMediaUrl } from './landingData';

function Initials({ name }) {
  return <span>{String(name || 'V').slice(0, 2).toUpperCase()}</span>;
}

export default function CinemaRanking({ ranking, rankingLoading, rankingError }) {
  const podiumRef = useRef(null);
  const podium = ranking ? [...ranking].sort((a, b) => {
    const order = { 2: 0, 1: 1, 3: 2 };
    return (order[a.position] ?? 9) - (order[b.position] ?? 9);
  }) : [];

  useEffect(() => {
    if (!podiumRef.current || !podium.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const tween = gsap.fromTo(podiumRef.current.children, { y: 110, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 1, stagger: .12, ease: 'power4.out', scrollTrigger: { trigger: podiumRef.current, start: 'top 85%', once: true } });
    return () => tween.kill();
  }, [podium.length]);

  return (
    <>
      <section id="film" className="dl-cinema">
        <div className="dl-cinema-copy dl-reveal">
          <div className="dl-section-code">02 / THE FILM</div>
          <h2>To nie jest kolejna<br /><em>aplikacja do jazdy.</em></h2>
        </div>
        <div className="dl-film-shell dl-reveal">
          <div className="dl-film-meta"><span>VROOM // OFFICIAL FILM</span><b>FULL SCREEN / SOUND ON</b></div>
          <div className="dl-film-frame">
            <iframe
              src="https://www.youtube.com/embed/IRzoMVlVwUU?si=wKykBq8Zf-o6dbzU"
              title="Poznaj projekt VROOM"
              loading="lazy"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
        </div>
      </section>

      <section id="ranking" className="dl-ranking">
        <div className="dl-ranking-aura" aria-hidden="true" />
        <div className="dl-section-heading dl-section-heading-centered dl-reveal">
          <div className="dl-section-code">03 / LIVE RANKING</div>
          <h2>Asfalt pamięta<br /><em>najlepszych.</em></h2>
          <p>Top 3 kierowców bieżącego miesiąca. Prawdziwe punkty, prawdziwa rywalizacja.</p>
        </div>
        {rankingLoading ? (
          <div className="dl-ranking-state"><span className="dl-loader" /> ŁĄCZENIE Z RANKINGIEM</div>
        ) : rankingError ? (
          <div className="dl-ranking-state dl-ranking-error"><b>SIGNAL LOST</b><span>Ranking jest chwilowo niedostępny. Spróbuj ponownie za moment.</span></div>
        ) : podium.length === 0 ? (
          <div className="dl-ranking-state dl-ranking-error"><b>START SEZONU</b><span>Pierwsze miejsca czekają na kierowców.</span></div>
        ) : (
          <div className="dl-podium" ref={podiumRef}>
            {podium.map((player) => (
              <article className={`dl-podium-player dl-rank-${player.position}`} key={`${player.position}-${player.username}`}>
                <div className="dl-podium-position">#{player.position}</div>
                <div className="dl-podium-avatar">
                  {player.avatar ? <img src={resolveMediaUrl(player.avatar)} alt={`Avatar ${player.username}`} /> : <Initials name={player.username} />}
                  <i aria-hidden="true" />
                </div>
                <h3>{player.username}</h3>
                <p>{Number(player.score || 0).toLocaleString('pl-PL')} <span>PKT</span></p>
                <div className="dl-podium-base"><b>{player.position}</b><span>VROOM // MONTHLY</span></div>
              </article>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
